import { LoadingSpinner } from "MVVM/Components/Lottie";
import { LoadingContainer, LoadingText } from "../styledComponents";

export const Checking = () => {
  return (
    <LoadingContainer>
      <LoadingSpinner width={40} height={40} />
      <LoadingText>Checking storage...</LoadingText>
    </LoadingContainer>
  );
};
